import { AutomationSourcesPage } from 'features/automation-sources';

export const AdminAutomationSourcesPage = () => <AutomationSourcesPage />;
